import { FC, ReactElement } from 'react'
import { Box, styled } from '@mui/material'
import { useLocation, Navigate } from 'react-router-dom'
import { Loader } from '@icanbwell/ui-toolkit'

const ProgressContainer = styled(Box)({
  height: '100vh',
  width: '100vw',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

type Props = {
  loading: boolean
  redirect?: boolean
  redirectTo: string
}

const AuthGuardBase: FC<Props> = ({ redirect, loading, redirectTo, children }) => {
  const location = useLocation()
  if (loading) {
    return (
      <ProgressContainer>
        <Loader  />
      </ProgressContainer>
    )
  }
  if (!loading && redirect) {
    return <Navigate to={redirectTo} state={{ from: location }} />
  }
  return children as ReactElement
}

export default AuthGuardBase
